import { useEffect, useState } from 'react';
import { ArrowLeftOutlined, DeleteOutlined, DownOutlined, PlusOutlined, UpOutlined } from '@ant-design/icons';
import { Typography, Flex, Input, Select, Button, Divider, message, Tooltip } from 'antd';
import { getAllWidgets } from '../../../utils/formsHelper';
import { comparatorData } from '../../../utils/comparatorData';
import ConditionValue from '../../form-editor/conditionManager/ConditionValue';
import UserRoleDropdown from '../../UserRoleDropdown';
import ScenarioContainer from './ScenarioContainer';
import { useTranslation } from 'react-i18next';

const operators = [
    { label: 'AND', value: '&&' },
    { label: 'OR', value: '||' }
]

const AddConditionForm = ({ setShowForm, selectedCondition, selectedForms, saveConditions, selectedStep, handleCancel }) => {
    const { t } = useTranslation();
    const [data, setData] = useState(
        {
            name: '',
            scenarios: [
                {
                    conditions: [
                        { reference: "", comparator: "", value: "", operator: "" },

                    ],
                    operator: "",
                    action: "",
                    approvers: { user: [], group: [], role: [] },
                    required: true
                }
            ]
        }
    )
    const [formElements, setFormElements] = useState([])
    const [formFields, setFormFields] = useState([])
    const [scenarioFields, setScenarioFields] = useState([])
    const [expandConditions, setExpandConditions] = useState(true)

    useEffect(() => {
        // if (selectedCondition.conditionId) {
        if (selectedCondition.name) {
            setData({ ...selectedCondition })
        }
    }, [selectedCondition])

    useEffect(() => {
        if (selectedForms.length > 0) {
            let tempFields = [], tempElements = []
            selectedForms.forEach(form => {
                tempElements = tempElements.concat(form.items)
                let currentFields = getAllWidgets(form.items);
                currentFields = currentFields.map(field => {
                    return { ...field, label: field.label + " - " + form?.formHeader?.label, value: field.id, }
                })
                tempFields = tempFields.concat(currentFields)
            })
            let reqScenarioFields = tempFields.filter(field => field.formType !== "infoForm")
            setScenarioFields(reqScenarioFields)
            setFormFields(tempFields)
            setFormElements(tempElements)
        }
    }, [selectedForms])

    const handleChange = (e) => {
        setData({ ...data, name: e.target.value })
    }

    const handleScenarioChange = (key, val, scenarioIndex, conditionIndex) => {
        let updatedData = data.scenarios.map((scenario, index) => {
            if (scenarioIndex === index) {
                if (conditionIndex === undefined) {
                    return { ...scenario, [key]: val }
                }
                let reqConditions = scenario.conditions.map((condition, conditionIdx) => {
                    if (conditionIdx === conditionIndex) {
                        if (key === "reference") {
                            return { [key]: val }
                        } else if (key === "comparator") {
                            return { "reference": condition.reference, [key]: val }
                        } else {
                            return { ...condition, [key]: val }
                        }
                    } else {
                        return { ...condition }
                    }
                })
                return { ...scenario, conditions: reqConditions }

            } else {
                return { ...scenario }
            }
        })
        setData({ ...data, scenarios: updatedData })
    }

    const addCondition = (scenarioIndex) => {
        let updatedData = data.scenarios.map((scenario, index) => {
            if (scenarioIndex === index) {
                let reqConditions = [...scenario.conditions]
                // let lastCondition = reqConditions.pop()
                // lastCondition.operator = "&&"
                reqConditions.push({ "reference": "", "comparator": "", "value": "" })
                return { ...scenario, conditions: reqConditions, operator: "&&" }
            } else {
                return { ...scenario }
            }
        })
        setData({ ...data, scenarios: updatedData })
    }

    const deleteCondition = (scenarioIndex, conditionIndex) => {
        let updatedData = data.scenarios.map((scenario, index) => {
            if (scenarioIndex === index) {
                let reqConditions = scenario.conditions.filter((condition, idx) => idx !== conditionIndex)
                return { ...scenario, conditions: reqConditions }
            } else {
                return { ...scenario }
            }
        })
        setData({ ...data, scenarios: updatedData })
    }

    const addScenario = () => {
        let updatedData = {
            ...data, scenarios: data.scenarios.concat({
                conditions: [
                    { reference: "", comparator: "", value: "" }
                ],
                operator: "",
                action: "",
                approvers: { user: [], group: [], role: [] },
                required: true
            }
            )
        }
        setData(updatedData)
    }

    const deleteScenario = (scenarioIndex) => {
        let updatedData = {
            ...data, scenarios: data.scenarios.filter((scenario, index) => index !== scenarioIndex)
        }
        setData(updatedData)
    }

    const submitConditions = () => {
        if (!data.name) {
            message.error(t('Condition name is missing'));
            return
        }
        saveConditions({ ...data, nodeId: selectedStep.id })
    }

    const getComparators = (reference) => {
        let refObj = formFields.find(field => field.id === reference)
        if (refObj) {
            return (comparatorData[refObj.formType] || []).map(comp => ({ ...comp, label: t(comp.label) }))
        }
        return []
    }

    const getFormType = (reference) => {
        let refObj = formFields.find(field => field.id === reference)
        if (refObj) {
            return refObj
        }
        return { formType: "inputForm" }
    }

    const handleScenarioAction = (scenarioIndex, key, value) => {
        let reqScenarios = [...data.scenarios]
        reqScenarios = reqScenarios.map((scenario, index) => {
            if (index === scenarioIndex) {
                return { ...scenario, [key]: value }
            }
            return { ...scenario }
        })
        let updatedData = {
            ...data, scenarios: reqScenarios
        }

        setData(updatedData)
    }

    const handleApproverSelection = (scenarioIndex, key, values) => {
        handleScenarioAction(scenarioIndex, key, values)
    }
    return (
        <div style={{ display: "flex", flexDirection: "column", height: "100%", minHeight: "100%" }}>

            <Flex align="center" className='condition-header' gap={8}>
                <ArrowLeftOutlined className="icon-medium" onClick={() => setShowForm(false)} />
                <Typography.Title level={5} className='margin-0'>{t('New Condition')}</Typography.Title>
            </Flex>
            <div style={{ flex: 1, overflowY: "auto", overflowX: "hidden" }}>
                <div className='condition-form'>
                    <div>
                        <div className='condition-form-label mb-2'>{t('Condition name')}</div>
                        <Input onChange={handleChange} value={data.name} />
                    </div>
                    <div className='workflow-condition'>
                        <div className='scenario-body'>

                            {

                                data.scenarios.map((scenario, scenarioIndex) => {
                                    return (
                                        <ScenarioContainer data={data} scenario={scenario} scenarioIndex={scenarioIndex}
                                            addCondition={addCondition}
                                            deleteCondition={deleteCondition}
                                            deleteScenario={deleteScenario}
                                            handleScenarioChange={handleScenarioChange}
                                            handleScenarioAction={handleScenarioAction}
                                            handleApproverSelection={handleApproverSelection}
                                            operators={operators}
                                            getComparators={getComparators}
                                            getFormType={getFormType}
                                            scenarioFields={scenarioFields}
                                        />

                                    )
                                })
                            }

                        </div>

                    </div>
                    <Button className="condition-button" style={{ marginTop: "8px" }} icon={<PlusOutlined />} onClick={addScenario}>{t('Add group')}</Button>
                </div>
            </div>
            <div className='condition-actions'>
                <Divider style={{ margin: "20px 0 0 0" }} />
                <div className='flex gap-2' style={{ width: "100%" }}>

                    <Button className='submit-button' onClick={submitConditions}>{t('Save Condition')}</Button>
                    <Button onClick={handleCancel}>{t('Cancel')}</Button>
                </div>
            </div>
        </div>
    )
}

export default AddConditionForm